import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";

const STATS = [
  { value: "10+", label: "Years Experience" },
  { value: "500+", label: "Valued Clients" },
  { value: "99%", label: "Success Rate" },
  { value: "24/7", label: "Expert Support" },
];

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1771964427768-1f8ae7794358?auto=format&fit=crop&w=1920&q=80"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#0A0D14]/88" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0D14]/60 via-transparent to-[#0A0D14]" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 md:px-12 max-w-7xl pt-32 pb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <p className="font-work text-sm font-semibold tracking-[0.25em] text-[#D4AF37] uppercase mb-6">
            AVS Associates & Co
          </p>

          <h1 className="font-outfit text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight text-white leading-[1.1] mb-8">
            Excellence in{" "}
            <span className="gold-shimmer font-medium">Taxation</span>
            <br />
            & Legal Advisory
          </h1>

          <p className="font-work text-base md:text-lg text-[#94A3B8] leading-relaxed max-w-xl mb-10">
            Navigating complex financial landscapes with precision and integrity.
            Comprehensive GST, Income Tax, Audit, and Legal services under one roof.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo("#services")}
              data-testid="hero-services-btn"
              className="bg-[#D4AF37] text-[#0A0D14] font-work font-medium px-8 py-4 hover:bg-[#F4D068] transition-colors inline-flex items-center gap-2"
            >
              Our Services
              <ArrowRight size={16} />
            </button>
            <button
              onClick={() => scrollTo("#contact")}
              data-testid="hero-contact-btn"
              className="border border-[#D4AF37] text-[#D4AF37] font-work font-medium px-8 py-4 hover:bg-[#D4AF37] hover:text-[#0A0D14] transition-colors"
            >
              Contact Us
            </button>
          </div>
        </motion.div>
      </div>

      {/* Stats Bar */}
      <div className="relative z-10 border-t border-white/5 bg-[#0A0D14]/70 backdrop-blur-md">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl">
          <div className="grid grid-cols-2 md:grid-cols-4">
            {STATS.map((stat, i) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 + i * 0.15, duration: 0.6 }}
                data-testid={`stat-${i}`}
                className="py-6 md:py-8 text-center border-r border-white/5 last:border-r-0"
              >
                <div className="font-outfit text-2xl md:text-3xl font-light text-[#D4AF37]">
                  {stat.value}
                </div>
                <div className="font-work text-xs md:text-sm text-[#94A3B8] mt-1 tracking-wide">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollTo("#services")}
        data-testid="scroll-indicator"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 scroll-indicator hidden md:block"
      >
        <ChevronDown size={24} className="text-[#D4AF37]/60" />
      </button>
    </section>
  );
}
